import React from 'react'
import Pg8 from '../../../myapp/services/add-money/Pg/Pg8.jsx'

function PG8Page() {
  return (
    <Pg8/>
  )
}

export default PG8Page